<template>
	<div class="st">
		<div class="st-head">
			<v-icon small class="mr-1" color="primary">{{ icona }}</v-icon>
			<span class="st-title">{{ titolo }}</span>
		</div>
		<div class="st-options" role="radiogroup" :aria-label="titolo">
			<button
				v-for="o in opzioni"
				:key="o.code"
				type="button"
				role="radio"
				:aria-checked="o.code === value ? 'true' : 'false'"
				:disabled="o.disabled"
				class="st-option"
				:class="{ 'st-option--on': o.code === value }"
				@click="$emit('input', o.code)"
			>
				<v-icon small :color="o.code === value ? 'primary' : 'grey'" class="mr-2">{{ o.code === value ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}</v-icon>
				<span>{{ o.label }}</span>
				<span v-if="o.disabled" class="st-badge">In arrivo</span>
			</button>
		</div>
		<slot />
	</div>
</template>

<script>
// scelta fra le versioni grafiche di un blocco del sito (header, footer, checkout...): una card per opzione
export default {
	name: 'SceltaTema',
	props: {
		value: { type: String, default: '' },
		// [{ code, label, disabled }]: disabled = versione non ancora disponibile
		opzioni: { type: Array, default: () => [] },
		titolo: { type: String, required: true },
		icona: { type: String, default: 'mdi-view-dashboard-outline' },
	},
};
</script>

<style scoped>
.st + .st {
	margin-top: 16px;
	padding-top: 16px;
	border-top: 1px solid #eef2f7;
}
.st-head {
	display: flex;
	align-items: center;
	margin-bottom: 8px;
}
.st-title {
	font-size: 13px;
	font-weight: 600;
	color: #1f2d3d;
}
.st-options {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
	gap: 8px;
}
.st-option {
	display: flex;
	align-items: center;
	padding: 10px 12px;
	border: 1px solid #e1e7ef;
	border-radius: 8px;
	background: #fff;
	font-size: 13px;
	color: #1f2d3d;
	text-align: left;
	cursor: pointer;
	transition: border-color 0.15s, background 0.15s;
}
.st-option:hover:not(:disabled) {
	border-color: #9fb6d3;
}
.st-option:disabled {
	color: #8a97a8;
	cursor: not-allowed;
}
.st-badge {
	margin-left: auto;
	padding: 1px 6px;
	border-radius: 10px;
	background: #eef2f7;
	font-size: 10px;
	font-weight: 600;
	color: #5b6b7f;
}
.st-option--on {
	border-color: #01579b;
	background: #eef4fd;
	font-weight: 600;
}
.st-option:focus-visible {
	outline: 2px solid #01579b;
	outline-offset: 1px;
}
</style>
